;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { createTheme } from "@mui/material/styles"
import { red } from "@mui/material/colors"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_PRIMARY_COLOR,
  UI_STYLE_SECONDARY_COLOR,
  UI_STYLE_TERTIARY_COLOR,
  UI_STYLE_YELLOW_COLOR_BUTTON,
  UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED,
  UI_STYLE_BLACK_COLOR_BUTTON,
  UI_STYLE_BLACK_COLOR_BUTTON_PUSHED,
  UI_STYLE_HEADER_FONT,
  UI_STYLE_PRIMARY_FONT,
} from "../lib/constants"

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: UI_STYLE_PRIMARY_COLOR,
    },
    secondary: {
      main: UI_STYLE_SECONDARY_COLOR,
    },
    tertiary: {
      main: UI_STYLE_TERTIARY_COLOR,
    },
    error: {
      main: red.A400,
    },
    text: {
      primary: UI_STYLE_PRIMARY_BLUE_BLACK,
    },
  },
  typography: {
    fontFamily: UI_STYLE_PRIMARY_FONT,
    body1: {
      fontFamily: UI_STYLE_PRIMARY_FONT,
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "25px",
      color: UI_STYLE_PRIMARY_BLUE_BLACK,

      "@media (min-width:600px)": {
        fontSize: "18px",
        lineHeight: "25px",
      },
    },
    body2: {
      fontFamily: UI_STYLE_PRIMARY_FONT,
      fontWeight: 400,
      fontSize: "1rem",
      color: UI_STYLE_PRIMARY_BLUE_BLACK,
      lineHeight: "1rem",
    },

    h1: {
      fontFamily: UI_STYLE_HEADER_FONT,
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "28px",
      lineHeight: "34px",

      letterSpacing: "0.07em",
      color: UI_STYLE_PRIMARY_BLUE_BLACK,

      "@media (min-width:600px)": {
        fontSize: "36px",
        lineHeight: "43px",
      },
    },
    h2: {
      fontFamily: UI_STYLE_HEADER_FONT,
      fontWeight: 500,
      fontSize: "22px",
      letterSpacing: "0.07em",
      lineHeight: "28px",
      "@media (min-width:600px)": {
        fontSize: "26px",
        lineHeight: "32px",
      },
    },
    h3: {
      fontFamily: UI_STYLE_HEADER_FONT,
      fontWeight: 500,
      fontSize: "20px",
      letterSpacing: "0.07em",
      lineHeight: "24px",
      "@media (min-width:600px)": {
        fontSize: "23px",
        lineHeight: "28px",
      },
    },
    h4: {
      fontFamily: UI_STYLE_HEADER_FONT,
      fontWeight: 500,
      fontSize: "1.45rem",
      "@media (min-width:600px)": {
        fontSize: "1.6rem",
      },
      "@media (min-width:900px)": {
        fontSize: "1.8rem",
      },
    },
    h5: {
      fontFamily: UI_STYLE_HEADER_FONT,
      fontWeight: 500,
      fontSize: "1.125rem",
      "@media (min-width:600px)": {
        fontSize: "1.3rem",
      },
      "@media (min-width:900px)": {
        fontSize: "1.5rem",
      },
    },
    h6: {
      fontFamily: UI_STYLE_HEADER_FONT,
      fontWeight: 500,
      fontSize: "1rem",
      "@media (min-width:600px)": {
        fontSize: "1.1rem",
      },
      "@media (min-width:900px)": {
        fontSize: "1.2rem",
      },
    },
  },
})

export default theme
